import { useQuery } from '@tanstack/react-query';
import { isNotNullish } from '@utils/isNotNullish';
import request from '@utils/request';
import { TableDepositValueSchema } from '../schemas/TableDepositValues.schema';

export const useGetTableDepositValue = (
  propertyId: string,
  guests: number,
  date: string,
  restautantConfigId: string,
  menuId: string | undefined
) => {
  return useQuery({
    queryFn: () => getTableDepositValue(propertyId, guests, date, restautantConfigId, menuId),
    queryKey: getTableDepositValueKey(propertyId, guests, date, restautantConfigId, menuId),
    enabled: isNotNullish(restautantConfigId),
  });
};

export async function getTableDepositValue(
  propertyId: string,
  guests: number,
  date: string,
  restautantConfigId: string,
  menuId?: string
) {
  const url = isNotNullish(menuId)
    ? `store/${propertyId}/table-deposit/calculate-value/${guests}/${date}/${restautantConfigId}/${menuId}`
    : `store/${propertyId}/table-deposit/calculate-value/${guests}/${date}/${restautantConfigId}`;

  const response = await request.store.get(url);

  const result = TableDepositValueSchema.safeParse(response.data.data);
  if (result.success) {
    return result.data;
  }

  return null;
}

export const getTableDepositValueKey = (
  propertyId: string,
  guests: number,
  date: string,
  restautantConfigId: string,
  menuId?: string
) => ['oj-api', 'tableDepositValue', propertyId, guests, date, restautantConfigId, menuId];
